/**
 * SettingsSidebar — TAL-1
 *
 * Left sidebar navigation for the Settings modal.
 * Panel registry with icons + labels. Highlights active panel.
 * Matches Writers Factory dark theme aesthetic.
 */

import React from 'react';

export interface SettingsPanel {
    id: string;
    label: string;
    icon: string;
    adminOnly: boolean;
    component: React.ComponentType<{ mode: 'admin' | 'tenant' }>;
}

interface SettingsSidebarProps {
    panels: SettingsPanel[];
    activePanel: string;
    onSelectPanel: (id: string) => void;
}

export const SettingsSidebar: React.FC<SettingsSidebarProps> = ({
    panels,
    activePanel,
    onSelectPanel,
}) => {
    return (
        <nav className="w-48 border-r border-gray-800 bg-[#0a0a0a] py-2 flex-shrink-0">
            <div className="px-4 py-2 mb-2">
                <span className="text-[10px] font-mono uppercase tracking-widest text-gray-600">
                    Settings
                </span>
            </div>
            {panels.map((panel) => {
                const isActive = panel.id === activePanel;
                return (
                    <button
                        key={panel.id}
                        onClick={() => onSelectPanel(panel.id)}
                        className={`w-full flex items-center gap-3 px-4 py-2.5 text-left text-xs font-mono transition-colors
                            ${isActive
                                ? 'bg-gray-800/60 text-[#39FF14] border-l-2 border-[#39FF14]'
                                : 'text-gray-400 hover:text-gray-200 hover:bg-gray-800/30 border-l-2 border-transparent'
                            }`}
                    >
                        <span className="text-sm">{panel.icon}</span>
                        <span className="uppercase tracking-wider">{panel.label}</span>
                    </button>
                );
            })}
        </nav>
    );
};
